import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const AuthTokenSetSchema = z.object({
  accessToken: z.string(),
  scope: z.string().optional(),
  refreshToken: z.string().optional(),
  expiresAt: z.number(),
})

export type AuthTokenSet = ZodSimplify<typeof AuthTokenSetSchema>
